import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { Container, Text, Flex, Box, Button, Center } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

function PageNotFound() {
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <Container>
      <Helmet>
        <title>Page not found</title>
      </Helmet>
      <Center height="100vh">
        <Box p="16px" maxW="800px" w="100%" overflow="hidden">
            <Box
              p="10"
              pb="16"
              w="100%"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              textAlign="center"
            >
              <Text
                fontSize="50px"
                fontWeight="550"
                textTransform="uppercase"
              >
                404
              </Text>

              <Text mt="4" fontWeight="500">
                {t("We can’t find the page you’re looking for.")}
              </Text>

              <Box>
                <Flex justifyContent="center">
                  <Button
                    onClick={() => history.push("/")}
                    textTransform="uppercase"
                    id="continue-button"
                    mt="10"
                    fontWeight="bold"
                    bg="#303030"
                    color="white"
                    variant="solid"
                    minW="120px"
                    pl="10"
                    pr="10"
                    _hover={{ bg: "#303030" }}
                  >
                    {t("Go Home")}
                  </Button>
                </Flex>
              </Box>
            </Box>
        </Box>
      </Center>
    </Container>
  );
}

export default PageNotFound;
